import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useTranslation } from 'react-i18next';
import { isNullUndefinedOrEmpty } from '../../../../common/Helpers';
import { Icon } from '@fluentui/react';
import { Col, Row } from 'react-bootstrap';
import SidePanelAlerts from './SidePanelAlerts';
import { ENUM_NOTIFICACION_CLASE_BANDEJA } from '../../../../common/Dictionaries';
import { action_updateAlertDialogTitle, action_updateIsPanelNotificationOpen, action_updateNotificationSearchIdentifiers } from '../../../../reducers/actions/SITE/actions';
import './DropDownPanel.css'

const CumplimientoObligaciones = (props) => {
    const { t } = useTranslation();
    const dispatch = useDispatch();

    const {
        _edpPrepareHeader: edpPrepareHeader,
    } = useSelector((state) => state.edpPreparationState);

    const {
        _isPanelNotificationAlertOpen: isPanelNotificationAlertOpen,
        _alertSearchIdentifiers: alertSearchIdentifiers,
    } = useSelector((state) => state.notificationAlertState);

    const inputParam_ElementId = !isNullUndefinedOrEmpty(props.inputParam_ElementId) ? props.inputParam_ElementId : 0;
    const inputParam_EdPId = !isNullUndefinedOrEmpty(props.inputParam_EdPId) ? props.inputParam_EdPId : 0;

    // Solo la celda de valor de "Requisitos de aprobación" lleva color (sin color / rojo / verde, según obligacionStyle).
    // "Total de obligaciones" y "Otras obligaciones" van siempre sin color. Con fondo rojo o verde el texto va en blanco.
    const requisitosStyle = edpPrepareHeader.obligacionStyle;
    const isRequisitosSinColor = isNullUndefinedOrEmpty(requisitosStyle) || requisitosStyle === 'obligacion_sin_color';

    const formatValue = (cumplidas, total) => `${cumplidas ?? 0} / ${total ?? 0}`;

    const onViewCONotifications = () => {
        dispatch(action_updateNotificationSearchIdentifiers(inputParam_ElementId, inputParam_EdPId));
        dispatch(action_updateAlertDialogTitle('data-lang-boxname-obligations'))
        dispatch(action_updateIsPanelNotificationOpen(true));
    };

    const headerCellStyle = { padding: '2px 6px', fontWeight: 'normal', backgroundColor: '#f3f2f1', borderBottom: '1px solid #a19f9d' };
    const valueCellStyle = { padding: '2px 6px', fontWeight: 'bold' };

    return (
        <Row>
            <Col>
                <Row>
                    <Col>
                        {t('data-lang-lbl-epobligationachieve')}
                        <Icon iconName={"PaddingBottom"} styles={{ root: { marginLeft: 8, cursor: 'pointer' } }} onClick={onViewCONotifications} />
                    </Col>
                </Row>
                <div className='dropdown-container-cumplimiento w-100'>
                    <table
                        className='w-100 text-center'
                        style={{ cursor: 'pointer', borderCollapse: 'collapse', border: '1px solid #a19f9d' }}
                        onClick={onViewCONotifications}
                    >
                        <thead>
                            <tr>
                                <th style={headerCellStyle}>{t('data-lang-lbl-epobligation-total')}</th>
                                <th style={{ ...headerCellStyle, borderLeft: '1px solid #a19f9d' }}>{t('data-lang-lbl-epobligation-requirements')}</th>
                                <th style={{ ...headerCellStyle, borderLeft: '1px solid #a19f9d' }}>{t('data-lang-lbl-epobligation-others')}</th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr>
                                <td style={valueCellStyle}>
                                    {formatValue(edpPrepareHeader.obligacionTotalCumplida, edpPrepareHeader.obligacionTotal)}
                                </td>
                                <td
                                    className={isRequisitosSinColor ? undefined : requisitosStyle}
                                    style={{ ...valueCellStyle, borderLeft: '1px solid #a19f9d', color: isRequisitosSinColor ? undefined : 'white' }}
                                >
                                    {formatValue(edpPrepareHeader.obligacionRequisitosCumplida, edpPrepareHeader.obligacionRequisitosTotal)}
                                </td>
                                <td style={{ ...valueCellStyle, borderLeft: '1px solid #a19f9d' }}>
                                    {formatValue(edpPrepareHeader.obligacionOtrasCumplida, edpPrepareHeader.obligacionOtrasTotal)}
                                </td>
                            </tr>
                        </tbody>
                    </table>
                    {
                        isPanelNotificationAlertOpen && !isNullUndefinedOrEmpty(alertSearchIdentifiers.rootId) && !isNullUndefinedOrEmpty(alertSearchIdentifiers.itemId) &&
                        <SidePanelAlerts inputParam_NotificationType={ENUM_NOTIFICACION_CLASE_BANDEJA.EDP} />
                    }
                </div>
            </Col>
        </Row>
    );
};

export default CumplimientoObligaciones;
